import type { Move } from '../../../schemas/move';
import { guerrieroArchetypeMoves } from './archetypes';
import {
  guerrieroInitialMoves,
  guerrieroStartingAutoMoves,
  guerrieroStartingChoiceMoves,
} from './initial';
import { guerrieroAdvanced2to5Moves } from './advanced-2-5';
import { guerrieroAdvanced6to10Moves } from './advanced-6-10';

export {
  guerrieroArchetypeMoves,
  guerrieroInitialMoves,
  guerrieroStartingAutoMoves,
  guerrieroStartingChoiceMoves,
  guerrieroAdvanced2to5Moves,
  guerrieroAdvanced6to10Moves,
};

/**
 * Catalogo completo delle mosse del Guerriero (manuale V1, sezione "Il Guerriero").
 *
 * Aggregato di:
 *  - 5 archetipi (`class_special`)
 *  - 3 mosse iniziali automatiche + 2 mosse iniziali di scelta (`starting`)
 *  - 16 mosse avanzate L2-5 (`advanced_2_5`)
 *  - 14 mosse avanzate L6-10 (`advanced_6_10`)
 *
 * Totale: 40 mosse.
 */
export const guerrieroMoves: readonly Move[] = [
  ...guerrieroArchetypeMoves,
  ...guerrieroInitialMoves,
  ...guerrieroAdvanced2to5Moves,
  ...guerrieroAdvanced6to10Moves,
];
